import { useState, useEffect, useRef } from "react";

const API = process.env.REACT_APP_API_URL;

export function useStage2Reveal({ code, playerId, stage }) {
  const [showStage2Reveal, setShowStage2Reveal] = useState(false);
  // Ref pour ne déclencher qu'une seule fois par session de composant
  const hasTriggeredRef = useRef(false);

  useEffect(() => {
    if (!code || !playerId || stage !== 2) return;

    const checkReveal = async () => {
      // Si déjà déclenché, ne plus vérifier
      if (hasTriggeredRef.current) return;

      try {
        const response = await fetch(`${API}/api/sessions/${code}`);
        const state = await response.json();

        const shownPlayers = Array.isArray(state.infraState?.stage2RevealShownPlayers)
          ? state.infraState.stage2RevealShownPlayers
          : [];

        if (
          state.infraState?.stage2RevealTriggered &&
          !shownPlayers.includes(Number(playerId))
        ) {
          // Marquer immédiatement avant de setState pour éviter double-déclenchement
          hasTriggeredRef.current = true;
          setShowStage2Reveal(true);

          // Marquer comme vu côté back (fire and forget)
          fetch(`${API}/api/sessions/${code}/stage2-reveal-seen`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ playerId: Number(playerId) }),
          }).catch(console.error);
        }
      } catch (error) {
        console.error("Error checking stage2 reveal:", error);
      }
    };

    const interval = setInterval(checkReveal, 2000);
    checkReveal();

    return () => clearInterval(interval);
  }, [code, playerId, stage]);

  return { showStage2Reveal, setShowStage2Reveal };
}